export default class Menu {
    constructor() {
        this.html = document.querySelector('html');
        this.header = document.querySelector('header');
        this.toggleButton = document.querySelector('#menu-toggle');
        this.menuArrows = document.querySelectorAll('.menu-item-has-children > .menu-arrow');
        this.dropdownLinks = document.querySelectorAll('.menu-item-has-children > a');
        this.menuSubmenus = document.querySelectorAll('.menu-item-has-children > .sub-menu');
        this.arrowClickEvent();
        this.submenuMouseEvents();
        this.menuEventListeners();
    }
    menuEventListeners() {
        if (!this.toggleButton)
            return;
        this.toggleButton.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.header.classList.contains('mobile-open')) {
                this.header.classList.remove('mobile-open');
                this.html.classList.remove('no-scroll');
                return;
            }
            this.header.classList.add('mobile-open');
            this.html.classList.add('no-scroll');
        });
    }
    arrowClickEvent() {
        if (!this.dropdownLinks)
            return;
        this.dropdownLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                this.toggleMenu(link);
            });
        });
        this.menuArrows.forEach((arrow) => {
            arrow.addEventListener('click', (event) => {
                event.preventDefault();
                this.toggleMenu(arrow);
            });
        });
    }
    toggleMenu(item) {
        var _a, _b;
        const parentItem = item.parentElement;
        const isOpen = parentItem.classList.contains('is-open');
        // Close only siblings at the same level (and anything open nested inside them),
        // so opening a deeper item keeps its ancestors expanded.
        Array.from((_b = (_a = parentItem.parentElement) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []).forEach((sibling) => {
            if (sibling === parentItem)
                return;
            sibling.classList.remove('is-open');
            sibling.querySelectorAll('.menu-item-has-children.is-open')
                .forEach((nested) => nested.classList.remove('is-open'));
        });
        if (isOpen) {
            // Collapsing this item also collapses its open descendants.
            parentItem.classList.remove('is-open');
            parentItem.querySelectorAll('.menu-item-has-children.is-open')
                .forEach((nested) => nested.classList.remove('is-open'));
        }
        else {
            parentItem.classList.add('is-open');
        }
    }
    submenuMouseEvents() {
        this.menuSubmenus.forEach((subMenu) => {
            subMenu.addEventListener('mouseleave', (event) => {
                event.stopPropagation();
                subMenu.parentElement.classList.remove('is-open');
            });
        });
    }
}
